<template>
  <div>
    <div class="card ml-5 mr-5" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        {{ $t('authForm.regConfirmation') }}
      </div>
      <div>
        <a-form :form="form" @submit.prevent="submit">
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.storeName')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'storename',
                { rules: [{ required: true, message: $t('authForm.requiredStoreName') },  { validator: valiadateStoreName },] },
              ]"
              :placeholder="$t('authForm.storeName')"
              @keypress="inputStoreName"
              v-on:blur="handleBlur"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.storeUrl')"
            labelAlign="left"
            :help="$t('authForm.helpStoreUrl')"
          >
            <a-input
              v-decorator="[
                'storeurl',
                {
                  rules: [{
                    required: true,
                    message: $t('authForm.requiredStoreUrl'),
                  },
                  {
                    validator: valiadateStoreUrl
                  }],
                  initialValue: initialValueStoreUrl()
                },
              ]"
              :placeholder="$t('authForm.storeUrl')"
              @keypress="inputStoreUrl"
              v-on:blur="handleBlur"
              addonBefore="https://"
              :addonAfter="base_url"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.phoneNumber')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [{
                    required: true,
                    message: $t('authForm.requiredPhoneNumber'),
                    pattern: new RegExp(/[0-9\+]+/g, '')
                  }],
                },
              ]"
              :placeholder="$t('authForm.phoneNumber')"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.address')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'address',
                {
                  rules: [{
                    required: true,
                    message: $t('authForm.requiredAddress'),
                  }],
                },
              ]"
              :placeholder="$t('authForm.address')"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.address2')"
            labelAlign="left"
          >
            <a-input
              v-decorator="['address2']"
              :placeholder="$t('authForm.requiredAddress2')"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.country')"
            labelAlign="left"
          >
            <a-input
              v-decorator="['country', {
                initialValue: $store.state.data.regionCountry.label ? $store.state.data.regionCountry.label : null
              }]"
              :disabled="true"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.city')"
            labelAlign="left"
          >
            <a-select
              show-search
              :placeholder="$t('authForm.placeCity')"
              @change="handleChangeCity"
              v-decorator="[
                'city',
                {
                  rules: [{
                    required: true,
                    message: $t('authForm.requiredCity'),
                  }],
                },
              ]"
            >
              <a-select-option :value="city.label" v-for="(city, index) in cityList" :key="index">
                {{ city.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.area')"
            labelAlign="left"
            v-if="areaList.length"
          >
            <a-select
              show-search
              :placeholder="$t('authForm.placeArea')"
              v-decorator="[
                'area',
                {
                  rules: [{
                    required: true,
                    message: $t('authForm.requiredArea'),
                  }],
                },
              ]"
            >
              <a-select-option :value="area.label" v-for="(area, index) in areaList" :key="index">
                {{ area.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.zip')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'zip',
                {
                  rules: [{
                    required: true,
                    pattern: new RegExp('^[0-9]*$'),
                    message: $t('authForm.requiredZip')
                  }],
                  initialValue: form.getFieldValue('area') && initialPostCode()
                }
              ]"
              :maxLength="5"
              style="width: 50%"
            />
          </a-form-item>
          <!-- <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.bankInformation')"
            labelAlign="left"
          />
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.bankAccount')"
            labelAlign="left"
          >
            <a-select
              show-search
              :placeholder="$t('authForm.placeBankAcc')"
              v-decorator="[
                'bank',
                {
                  rules: [{
                    required: true,
                    message: $t('authForm.requiredBankAcc'),
                  }],
                },
              ]"
            >
              <a-select-option :value="bank.label+'_'+index" v-for="(bank, index) in bankList" :key="index">
                {{ bank.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.accountHolder')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'bank_holder_name',
                { rules: [{ required: true, message: $t('authForm.requiredBankAccName') }] },
              ]"
              :placeholder="$t('authForm.placeAccountHolder')"
            />
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.accountNo')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'account_number',
                {
                  rules: [{
                    required: true,
                    pattern: new RegExp('^[0-9]*$'),
                    message: $t('authForm.requiredAccountNo')
                  }]
                }
              ]"
              style="width: 50%"
            />
          </a-form-item> -->
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.idCard')"
            labelAlign="left"
          >
            <div v-if="image.length">
              <img :src="!!image[0].file ? image[0].url : `${image[0].url}?tr=w-50,h-50,cm-pad_resize,bg-FFFFFF`" style="width: 150px; height: 150px"/>
            </div>
            <div v-if="image.length">
              <a-popconfirm
                :title="$t('authForm.popUpRemoveImage')"
                ok-text="Remove"
                cancel-text="Cancel"
                @confirm="removeImage()"
              >
                <a-button size="small" icon="delete"> {{ $t('authForm.removeImage') }} </a-button>
              </a-popconfirm>
            </div>
            <div class="image-list__wrapper" v-if="!image.length">
              <div class="image-list__item" v-if="!image.length">
                <a-upload
                  :show-upload-list="false"
                  name="image"
                  list-type="picture-card"
                  class="image-uploader"
                  :beforeUpload="() => false"
                  @change="addImage"
                  v-decorator="[
                    'image'
                  ]"
                >
                  <div>
                    <a-icon type="plus" />
                  </div>
                </a-upload>
              </div>
            </div>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            label="NPWP"
            labelAlign="left"
            :extra="$t('authForm.extraNpwp')"
          >
            <div v-if="imageNpwp.length">
              <img :src="!!imageNpwp[0].file ? imageNpwp[0].url : `${imageNpwp[0].url}?tr=w-50,h-50,cm-pad_resize,bg-FFFFFF`" style="width: 150px; height: 150px"/>
            </div>
            <div v-if="imageNpwp.length">
              <a-popconfirm
                :title="$t('authForm.popUpRemoveImage')"
                ok-text="Remove"
                cancel-text="Cancel"
                @confirm="removeImageNpwp()"
              >
                <a-button size="small" icon="delete"> {{ $t('authForm.removeImage') }} </a-button>
              </a-popconfirm>
            </div>
            <div class="image-list__wrapper" v-if="!imageNpwp.length">
              <div class="image-list__item" v-if="!imageNpwp.length">
                <a-upload
                  :show-upload-list="false"
                  name="image"
                  list-type="picture-card"
                  class="image-uploader"
                  :beforeUpload="() => false"
                  @change="addImageNpwp"
                  v-decorator="[
                    'image-npwp'
                  ]"
                >
                  <div>
                    <a-icon type="plus" />
                  </div>
                </a-upload>
              </div>
            </div>
          </a-form-item>
          <!--a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('authForm.password')"
            labelAlign="left"
          >
            <a-input
              :placeholder="$t('authForm.password')"
              type="password"
              v-decorator="['password', { rules: [{ required: true, message: $t('authForm.requiredPassword') }]}]"
            />
          </a-form-item>-->
          <a-form-item>
            <a-checkbox
              v-decorator="['checkbox', { rules: [{ required: true, message: $t('authForm.requiredToc2'), }]}]"
              @change="handleCheckbox"
            >
              {{ $t('authForm.toc2') }}
            </a-checkbox>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              size="large"
              class="text-center"
              :loading="loading"
              htmlType="submit"
            >
              <strong> {{ $t('authForm.submitConRegister') }} </strong>
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div>
        <a-modal v-model="modalConfirmation" :title="$t('authForm.registerCompleted')" :closable="false" @cancel="cancelModal" @ok="cancelModal" :centered="true">
          <div class="row">
            <div class="col-12 d-flex justify-content-center text-center">
              <a-icon type="check-circle" style="color: green; font-size: 100px" />
            </div>
            <div class="col-12 d-flex justify-content-center text-center mt-4">
              <h6> {{ $t('authForm.tankYou') }} </h6>
            </div>
            <div class="col-12 d-flex justify-content-center text-center">
              <p class="text-muted"> {{ $t('authForm.registerCompleted') }} </p>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getImagePreview } from '@/services/image/utils'

// eslint-disable-next-line no-useless-escape
const specialChars = /[`!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/
// http://localhost:3070/reg-conf/6mWzDY1yj8PzjLv5BwN0

export default {
  name: 'RegisterConfirmation',
  data: function () {
    return {
      form: this.$form.createForm(this),
      image: [],
      imageNpwp: [],
      checkTermCondition: false,
      modalConfirmation: false,
    }
  },
  created () {
    this.$store.dispatch('user/LINKCONFIRMATIONDATAREQ', this.$route.params)
      .catch(() => {
        this.$router.push('/link-expired')
      })
  },
  methods: {
    initialValueStoreUrl () {
      if (!this.form.getFieldValue('storename')) {
        return ''
      }
      const value = this.form.getFieldValue('storename').toLowerCase().replace(/[^a-zA-Z0-9\-\s]+$/g, '-')
      return value.trim().toLowerCase().replace(/\s+/g, '-')
    },
    handleBlur (e) {
      const value = this.form.getFieldValue(e.target.id)
      const find = specialChars.test(value)
      if (find) {
        this.form.setFieldsValue({
          [e.target.id]: '',
        })
      } else {
        const target = [e.target.id]
        if (target === ['storename']) {
          this.form.setFieldsValue({
            target: value,
          })
        } else {
          this.form.setFieldsValue({
            target: value.trim().toLowerCase().replace(/\s+/g, '-'),
          })
        }
      }
    },
    valiadateStoreName(rule, value, callback) {
      const find = specialChars.test(value)
      if (find) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(this.$t('authForm.validator'))
      } else {
        callback()
      }
    },
    valiadateStoreUrl(rule, value, callback) {
      const find = specialChars.test(value)
      if (find) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(this.$t('authForm.validator'))
      } else {
        callback()
      }
    },
    inputStoreUrl (e) {
      const value = this.form.getFieldValue('storeurl').toLowerCase().replace(/[^a-zA-Z0-9\-\s]+$/g, '-')
      this.form.setFieldsValue({
        [e.target.id]: value.toLowerCase().replace(/\s+/g, '-'),
      })
    },
    inputStoreName (e) {
      const value = this.form.getFieldValue('storename').replace(/[^a-zA-Z0-9- ]/g, ' ')
      this.form.setFieldsValue({
        [e.target.id]: value,
      })
    },
    handleChangeCity (e) {
      const findValueCity = this.cityList.find(item => item.label === e)
      this.$store.dispatch('data/GETCITYLIST', { value: findValueCity.value, type: 'area' })
    },
    addImage({ file }) {
      getImagePreview(file)
        .then(url => {
          this.image.push({
            file,
            url,
          })
        })
    },
    removeImage () {
      this.image = []
    },
    addImageNpwp ({ file }) {
      getImagePreview(file)
        .then(url => {
          this.imageNpwp.push({
            file,
            url,
          })
        })
    },
    removeImageNpwp () {
      this.imageNpwp = []
    },
    handleCheckbox (e) {
      this.checkTermCondition = e.target.checked
    },
    cancelModal () {
      this.$router.push('/auth/login')
      this.form.resetFields()
    },
    initialPostCode () {
      const area = this.form.getFieldValue('area')
      const findValue = this.areaList.find(item => item.label === area)
      return findValue.postcode
    },
    submit () {
      this.form.validateFieldsAndScroll((errors, values) => {
        if (errors) return
        this.$store.dispatch('user/REGISTERCONFIRMATION', { image: this.image, imageNpwp: this.imageNpwp, link: this.$route.params, ...values })
          .then(_ => {
            this.modalConfirmation = true
          })
          .catch(err => {
            this.$notification.error({
              message: this.$t('authForm.registerFailed'),
              description: err.response?.data?.message || err.message,
            })
          })
      })
    },
  },
  computed: {
    ...mapState('data', {
      cityList: state => state.cityList,
      areaList: state => state.areaList,
      bankList: state => state.bankList,
    }),
    ...mapState('user', {
      base_url: state => state.base_url,
    }),
    loading() {
      return this.$store.state.user.loading
    },
  },
}
</script>

<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>

<style lang="scss">
.image-uploader {
  .ant-upload-select-picture-card {
    margin: 0 !important;
    width: 140px !important;
    height: 140px !important;

    img {
      max-width: 100%
    }

    i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
}
</style>
